import React from 'react';
import styled from 'styled-components';
import { TourItemType } from '@bb/domain/dist/types';

import { Card, List, ListItem, theme } from '../../components';
import AppointmentItemContainer from './AppointmentItemContainer';
import TourItemContainer from './TourItemContainer';
import TourSummary, { TourSummaryProps } from './TourSummary';
import { TourItemContent } from '../../Router/pages/TourEditPage/types';

type TourDetailContainerProps = {
  loading: boolean;
  tourSummary: TourSummaryProps;
  tourStops: Partial<TourItemContent>[];
};

const TourDetailContainer: React.FC<TourDetailContainerProps> = ({
  loading,
  tourSummary,
  tourStops,
}) => (
    <StyledTourDetail>
      <TourSummary {...tourSummary} />
      <List
        split={false}
        dataSource={tourStops}
        loading={loading}
        renderItem={stop => (
          <ListItem>
            {stop.type === TourItemType.ROUTE_STOP ? (
              <TourItemContainer {...stop} />
            ) : (
              <AppointmentItemContainer {...stop} />
            )}
          </ListItem>
        )}
      />
    </StyledTourDetail>
  );

export default TourDetailContainer;

const StyledTourDetail = styled(Card)`
  & .ant-card-body {
    padding: 16px;
    border: 1px solid ${theme.gray5};
    border-radius: 2px;
  }
  ${ListItem} {
    padding-top: 20px;
    padding-bottom: 0px;
  }
`;
